export default __webpack_public_path__ + "static/The Westin Manila - Brand Portfolio - Oct 2023-945da4182050fb9664c60c6f8c00ace9.png";